import { z } from "zod";

export const updateDriverStartSessionPayload = z.object({
  sessionUuid: z.uuid(),
  startOfUsage: z.iso.datetime(),
  driver: z.uuid(),
});

export type UpdateDriverStartSessionPayload = z.infer<
  typeof updateDriverStartSessionPayload
>;
